export const FOLLOWINGS_DATA = "FOLLOWINGS_DATA";
export const FOLLOWERS_DATA = "FOLLOWERS_DATA";
export const FOLLOW_UPDATED = "FOLLOW_UPDATED";
export const TOPIC_FOLLOWINGS_DATA = "TOPIC_FOLLOWINGS_DATA";
export const TOPIC_FOLLOW_UPDATED = "TOPIC_FOLLOW_UPDATED";

//Action Creator
export const setFollowings = (data) => {
    return { type: FOLLOWINGS_DATA, data }
}

export const setFollowers = (data) => {
    return { type: FOLLOWERS_DATA, data }
}

export const updateFollow = (data) => {
    return { type: FOLLOW_UPDATED, data }
}

export const setTopicFollowings = (data) => {
    return { type: TOPIC_FOLLOWINGS_DATA, data }
}

export const updateTopicFollow = (data) => {
    return { type: TOPIC_FOLLOW_UPDATED, data }
}